import PayrollDatesAndAmounts from './PayrollDatesAndAmounts';

export default PayrollDatesAndAmounts;
